module.exports = __webpack_public_path__ + "media/short-answer.0b3c8bbd.webm";